let defaultLocation = "SP";

export default {
  location: defaultLocation,
  all: null
}
